import { render, staticRenderFns } from "./SendNotification.vue?vue&type=template&id=f7d75edc&scoped=true&"
import script from "./SendNotification.vue?vue&type=script&lang=js&"
export * from "./SendNotification.vue?vue&type=script&lang=js&"
import style0 from "./SendNotification.vue?vue&type=style&index=0&id=f7d75edc&scoped=true&lang=css&"
import style1 from "./SendNotification.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d75edc",
  null
  
)

export default component.exports